import { render, staticRenderFns } from "./FooterConfigManagement.vue?vue&type=template&id=88569f60&scoped=true"
import script from "./FooterConfigManagement.vue?vue&type=script&lang=js"
export * from "./FooterConfigManagement.vue?vue&type=script&lang=js"
import style0 from "./FooterConfigManagement.vue?vue&type=style&index=0&id=88569f60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88569f60",
  null
  
)

export default component.exports